import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import home from "../../Assets/AppComponent/Logo/Home.svg";
import project from "../../Assets/AppComponent/Logo/PROJECT ORG.svg";
import plant from "../../Assets/AppComponent/Logo/PLANT.svg";
import Header from "../../Component/AppComponent/Header/Header";
import ReactTable from "../../Component/AppComponent/Table";
import {
  FetchProjectWbsActions,
  setplantListRetrieveActions,
  setCommonPostActions, SetCommonPostUpdateResponse,
  CreateProjectWbsUpdateActions,
UpdateProjectWbsUpdateActions
} from "../../Redux/Slice";
import ProjectWbsPopup from "../../Component/AppComponent/Popup/ProjectWbsPopup";
import Delete from "../../Component/AppComponent/Popup/Delete";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { projectWbsFetch } from "../../Context/apidata";
import axios from "axios";
function ProjectWpsTemplate() {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [plantPopup, setPlantPopup] = useState(false);
  const projectWbsNames = useSelector((state) => state.fetchProjectWbs);
  const [tabledata, settabledata] = useState([])
  const projectNames = useSelector((state) => state.fetchClient);
  const [editPayload, setEditPayload] = useState("");
  const [projectID, setProjectID] = useState("");
  const [plantID, setPlantID] = useState("");
  const { id } = useParams();
  const [deletePopup, setDeletePopup] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [datacount, setdatacount] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [ProjectwbsCommon, setProjectwbsCommon] = useState(false)
  const [Projectwbsdetails, setProjectwbsdetails] = useState()
  const [ProjectwbsCommonFolder, setProjectwbsCommonFolder] = useState(['ATTENDANCE', "INVOICE_WORKING", "DIG_INVOICE", "PF_DECLARATION", "ESI_DECLARATION", "ECR_STATEMENT", "GST_TAX CHALLAN", "PROFESSIONAL_TAX CHALLAN", "BANK_STATEMENT", "PO_AND_WO", "WAGE_REGISTER", "MATERIAL_DC", "OTHERS"])
  const [checkedItems, setCheckedItems] = useState([]);
  const CommonPostResData = useSelector((state) => state.CommonPostData.CommonPost)
  const createProjectWbsdata=useSelector((state)=>state.createProjectWbs)
  const updateProjectWbsdata =useSelector((state)=>state.updateProjectWbs) 
  useEffect(()=>{
    //console.log(createProjectWbsdata,updateProjectWbsdata,"ooo")

    if(createProjectWbsdata?.createProjectWbs?.data){
      dispatch(FetchProjectWbsActions(
        {
          id: id,
          search: searchQuery,
          page: dtpageindex
        }
  
      ));
      dispatch(CreateProjectWbsUpdateActions())
    }
    if(updateProjectWbsdata?.updateProjectWbsData?.data){
      dispatch(FetchProjectWbsActions(
        {
          id: id,
          search: searchQuery,
          page: dtpageindex
        }
  
      ));
      dispatch(UpdateProjectWbsUpdateActions())
    }
  },[createProjectWbsdata,updateProjectWbsdata])



  useEffect(() => {
    if (projectWbsNames?.ProjectWbs?.data?.length > 0) {
      settabledata(projectWbsNames?.ProjectWbs?.data)
      setdatacount(projectWbsNames?.ProjectWbs?.values)
    } else {
      settabledata([])
      setdatacount(0)

    }
  }, [projectWbsNames])



  useEffect(() => {
    dispatch(FetchProjectWbsActions(
      {
        id: id,
        search: searchQuery,
        page: dtpageindex
      }

    ));
    setPlantID(id);
  }, [searchQuery, dtpageindex]);

  // useEffect(() => {
  //   //console.log(plantNames, "plantNamesplantNamesplantNames");
  //   setPlantNameFeeder(plantNames);
  // }, [plantNames]);
  // const handleSubmit = () => {
  //   setPlantPopup(false);
  //   setEditPayload("");
  // };
  const handleEdit = (value) => {
    //console.log(value, "skldhfliashdfhio;sdihf;oajse");
    setEditPayload(value);
    setPlantPopup(true);
  };
  const handleRefresh = () => {
    dispatch(FetchProjectWbsActions({
      id: id,
      search: searchQuery,
      page: dtpageindex
    }));
  };
  const handleView = (value) => {
    // setPlantPopup(false);
    navigate(`/projects/${value.id}`);
  };
  const handleClearEditPayload = () => {
    setEditPayload("");
    dispatch(FetchProjectWbsActions({
      id: id,
      search: searchQuery,
      page: dtpageindex
    }));
  };
  useEffect(() => {

    if (projectWbsNames?.ProjectWbs?.data?.length > 0) {
      // plant
      setProjectID(projectWbsNames?.ProjectWbs?.data[0]?.project?.id);
      setPlantID(projectWbsNames?.ProjectWbs?.data[0]?.plant?.id);
    } else {
      setProjectID(projectNames?.clientListRetrieve?.data[0]?.project?.id);
      setPlantID(projectNames?.clientListRetrieve?.data[0]?.plant?.id);
    }
  }, [projectWbsNames]);

  const breadcrumbsData = [
    {
      id: "1",
      href: "/",
      source: home,
      title: "DASHBOARD",
    },
    {
      id: "2",
      href: `/plantProject/`,
      source: plant,
      title: "Plant",
    },
    {
      id: "3",
      href: `/projects/${plantID}`,
      source: project,
      title: "Project",
    },
  ];

  const handleDelete = (value, e) => {
    // //console.log(value, "jslajlfjsdaflsd");
    setSelectedData(value);
    setDeletePopup(true);
  };
  const handleConfirmDelete = (value) => {
    axios({
      method: "delete",
      url: projectWbsFetch,
      params: {
        id: selectedData.id,
      },
    }).then((res)=>{
      toast.info(`Deleted Successfully`, {
        position: toast.POSITION.TOP_RIGHT,
className: "toast-message",
      });
      dispatch(FetchProjectWbsActions(
        {
          id: id,
          search: searchQuery,
          page: dtpageindex
        }
  
      ));
    }).catch((err)=>{
      //console.log(err)
      toast.info(` ${err.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
className: "toast-message",
      });
  
    })    
    setDeletePopup(false);
  };

  const projectWbsColumn = useMemo(
    () => [
      {
        Header: "Plant",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p>{row.row.original.plant.plant}</p>
            </>
          );
        },
      },
      {
        Header: "Project",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p>{row.row.original.project.project}</p>
            </>
          );
        },
      },
      {
        Header: "Project Wbs",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {/* <div
                style={{
                  width: "50%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              > */}
              <span>{row.row.original.project_wbs}</span>
              {/* </div> */}
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <div className="plantProjectActions">
              <button
                type="button"
                onClick={(e) => handleEdit(row.row.original, e)}
              >
                <span style={{ color: "#ef4d39" }}>
                  {" "}
                  <i
                    class="fa-solid fa-pen"
                    style={{
                      fontSize: "13px",
                      paddingRight: "3px",
                      color: "#ef4d39",
                    }}
                  ></i>
                  Edit{" "}
                </span>
              </button>

              <button
                type="button"
                onClick={(e) => handleDelete(row.row.original, e)}
              >
                <span style={{ color: "#ef4d39" }}>
                  {" "}
                  <i
                    class="fa-regular fa-trash-can"
                    style={{
                      fontSize: "15px",
                      paddingRight: "3px",
                      paddingBottom: "3px",
                      color: "#ef4d39",
                    }}
                  ></i>
                  Delete{" "}
                </span>
              </button>
              {/* <button className="plant_common" onClick={(e) => {
                setProjectwbsdetails(row.row.original)
                setProjectwbsCommon(!ProjectwbsCommon)
              }}>
                <i class="bi bi-folder-plus"></i>
                ProjectWbs Common
              </button> */}
            </div>
          );
        },
      },
    ],
    []
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const handleSubmit = () => {
    if (checkedItems.length > 0) {
      dispatch(setCommonPostActions({
        type: "projectwbs",
        plant: Projectwbsdetails.plant.plant,
        project: Projectwbsdetails.project.project,
        projectwbs_common: checkedItems,
        projectwbs: Projectwbsdetails.project_wbs
      }))
    } else {
      toast.info(`Select Folder`, {
        position: toast.POSITION.TOP_RIGHT,
className: "toast-message",
      });
    }

  }

  useEffect(() => {
    setProjectwbsCommon(false)
    dispatch(SetCommonPostUpdateResponse())
    setCheckedItems([])
  }, [CommonPostResData])

  const handleCheckboxChange = (event) => {
    const target = event.target;
    const itemName = target.name;
    const isChecked = target.checked;

    if (isChecked) {
      setCheckedItems([...checkedItems, itemName]);
    } else {
      setCheckedItems(checkedItems.filter(item => item !== itemName));
    }
  };

  return (
    <div className={stateDisplay ? "outterContent" : "inner-Content"}>
      <Header breadCrumbsData={breadcrumbsData} heading="Project Wbs" />
      <div className="UserDetails" style={{ padding: "0" }}>
        <button
          type="submit"
          style={{
            background:
              "linear-gradient(90deg, #F26639 -3.66%, #F79C37 -3.65%, #EF4D39 100.34%)",
          }}
          className="custom-button"
          onClick={() => setPlantPopup(true)}
        >
          CREATE
        </button>
      </div>
      <ReactTable
        columns={projectWbsColumn}
        data={tabledata}
        pagesize={pagesize}
        pageindex={pageindex}
        dtpagesize={dtpagesize}
        dtpageindex={dtpageindex}
        datacount={datacount}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        search={true}

      />

      {/* {plantPopup && ( */}
      {/* <Plan tPopup */}
      <ProjectWbsPopup
        show={plantPopup}
        setShow={setPlantPopup}
        refresh={handleRefresh}
        editPayload={editPayload}
        plantID={plantID}
        projectID={projectID}
        handleClearEditPayload={handleClearEditPayload}
      />
      <Delete
        show={deletePopup}
        setShow={setDeletePopup}
        handleConfirmDelete={handleConfirmDelete}
        selectedData={selectedData}
      />
      {/* )} */}

      {ProjectwbsCommon && (
        <Modal
          // size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={ProjectwbsCommon}
          // onHide={handleClose}
          className="modelman"
        >
          <Modal.Header>
            <Modal.Title>
              Plant Common Folder
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <div>
                {ProjectwbsCommonFolder.map((ele, index) => (
                  <div key={index}>
                    <input
                      type="checkbox"
                      id={ele}
                      name={ele}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor={ele}>{ele}</label>
                  </div>
                ))}

              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => { setProjectwbsCommon(false); setCheckedItems([]) }}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              style={{ backgroundColor: "#f26639", border: "none" }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}

export default ProjectWpsTemplate;
